var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricTotalUsersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#EAE7FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F8F7FE",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8386 18.358C27.5964 17.3815 27.0444 16.5076 26.2626 15.8686C25.4291 15.1873 24.3856 14.8152 23.3092 14.8152C22.2327 14.8152 21.1893 15.1873 20.3558 15.8686C20.1743 16.017 20.0052 16.178 19.8495 16.35C20.8125 16.5248 21.7481 16.9395 22.5107 17.7021C22.7984 17.9898 23.0366 18.3022 23.2311 18.6313C24.7614 18.6345 26.2912 18.5434 27.8386 18.358Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6441 25.3498C22.4259 25.9888 22.9779 26.8628 23.2202 27.8392C23.2202 27.8392 20.4814 28.1962 18.6907 28.1962C16.9 28.1962 14.1613 27.8392 14.1613 27.8392C14.4036 26.8628 14.9556 25.9888 15.7374 25.3498C16.5709 24.6686 17.6142 24.2963 18.6907 24.2963C19.7672 24.2963 20.8106 24.6686 21.6441 25.3498Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6902 24.2963C20.4655 24.2963 21.4641 23.2977 21.4641 21.5225C21.4641 19.7472 20.4655 18.7486 18.6902 18.7486C16.9149 18.7486 15.9164 19.7472 15.9164 21.5225C15.9164 23.2977 16.9149 24.2963 18.6902 24.2963Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2202 27.839C22.9779 26.8626 22.4259 25.9886 21.6441 25.3496C20.8106 24.6683 19.7672 24.2962 18.6907 24.2962C17.6142 24.2962 16.5709 24.6683 15.7374 25.3496C14.9556 25.9886 14.4036 26.8626 14.1613 27.839",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6902 24.2963C20.4655 24.2963 21.4641 23.2977 21.4641 21.5225C21.4641 19.7472 20.4655 18.7486 18.6902 18.7486C16.9149 18.7486 15.9164 19.7472 15.9164 21.5225C15.9164 23.2977 16.9149 24.2963 18.6902 24.2963Z",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3091 14.8154C25.0844 14.8154 26.0829 13.8168 26.0829 12.0415C26.0829 10.2662 25.0844 9.26761 23.3091 9.26761C21.5337 9.26761 20.5351 10.2662 20.5351 12.0415C20.5351 13.8168 21.5337 14.8154 23.3091 14.8154Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3091 14.8154C25.0844 14.8154 26.0829 13.8168 26.0829 12.0415C26.0829 10.2662 25.0844 9.26761 23.3091 9.26761C21.5337 9.26761 20.5351 10.2662 20.5351 12.0415C20.5351 13.8168 21.5337 14.8154 23.3091 14.8154Z",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8387 18.358C27.5964 17.3815 27.0444 16.5076 26.2627 15.8686C25.4292 15.1873 24.3858 14.8152 23.3092 14.8152C22.2328 14.8152 21.1894 15.1873 20.3559 15.8686",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26753 18.358C9.50982 17.3815 10.0618 16.5076 10.8436 15.8686C11.6771 15.1873 12.7204 14.8152 13.7969 14.8152C14.8734 14.8152 15.9168 15.1873 16.7503 15.8686C16.9318 16.017 17.1009 16.178 17.2567 16.35C16.2937 16.5248 15.358 16.9395 14.5955 17.7021C14.3077 17.9898 14.0695 18.3022 13.8751 18.6313C12.3448 18.6345 10.8149 18.5434 9.26753 18.358Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7972 14.8154C12.0219 14.8154 11.0233 13.8168 11.0233 12.0415C11.0233 10.2662 12.0219 9.26761 13.7972 9.26761C15.5724 9.26761 16.571 10.2662 16.571 12.0415C16.571 13.8168 15.5724 14.8154 13.7972 14.8154Z",
    fill: "#E0D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7972 14.8154C12.0219 14.8154 11.0233 13.8168 11.0233 12.0415C11.0233 10.2662 12.0219 9.26761 13.7972 9.26761C15.5724 9.26761 16.571 10.2662 16.571 12.0415C16.571 13.8168 15.5724 14.8154 13.7972 14.8154Z",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26749 18.358C9.50978 17.3815 10.0618 16.5076 10.8435 15.8686C11.677 15.1873 12.7204 14.8152 13.7969 14.8152C14.8734 14.8152 15.9168 15.1873 16.7503 15.8686",
    stroke: "#715DE3",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricTotalUsersIcon);
export default __webpack_public_path__ + "static/media/metric_total_users_icon.69e5566c8ed5a6d104fb25b7af17f522.svg";
export { ForwardRef as ReactComponent };